import React from "react";
import * as styles from "./price.module.css";
import { Box, Grid, Typography } from "@mui/material";

const MobileView = ({
  node,
  quantityIncreaseHandler,
  quantityDecreaseeHandler,
  productQuantity,
}) => {
  const {
    productName,
    productImage,
    productDescriptionFirstTitle,
    productDescriptionSecondTitle,
    productPrice,
    productSaveText,
    productQuantitySelector,
    productOffText,
  } = node;

  let productImageUrl = "";
  if (productImage && productImage.asset) {
    productImageUrl = productImage.asset.url;
  }

  return (
    <Box className={styles.mobilePriceBox}>
      <Grid container justifyContent="center" alignItems={"center"} spacing={2}>
        <Grid item xs={2}>
          <input
            name="check"
            type="checkbox"
            className={styles.mobilePriceCheckbox}
          />
        </Grid>
        <Grid item xs={3}>
          <img src={productImageUrl} width={"100%"} />
        </Grid>
        <Grid item xs={7}>
          <p className={styles.mobilePriceProductName}>{productName}</p>
          <p className={styles.mobilePriceDescText}>
            {productDescriptionSecondTitle}
          </p>
          <p className={styles.mobilePriceText}>{productPrice}</p>
          <Typography
            className={styles.mobilePriceSaveText}
            dangerouslySetInnerHTML={{ __html: productSaveText }}
          />
          {productQuantitySelector ? (
            <Grid container spaing={1}>
              <Grid item xs={4}>
                <strong>
                  <span className={styles.quantityText}>Quantity:</span>
                </strong>
              </Grid>
              <Grid item xs={2}>
                <button
                  className={styles.quantityButton}
                  onClick={quantityDecreaseeHandler}
                >
                  -
                </button>
              </Grid>
              <Grid item xs={1}>
                <b className={styles.quantityNumberText}>{productQuantity}</b>
              </Grid>
              <Grid item x={2}>
                <button
                  className={styles.quantityButton}
                  onClick={quantityIncreaseHandler}
                >
                  +
                </button>
              </Grid>
            </Grid>
          ) : null}
        </Grid>
      </Grid>
    </Box>
  );
};

export default MobileView;
